/*
 * Solful — "second pair 50% off" cart nudge
 * ------------------------------------------------------------
 * Shows a popup the moment a customer's cart FIRST reaches 1 item
 * (i.e. right after they add their first pair), nudging them to add
 * a second pair for 50% off. Does NOT touch the discount itself —
 * `SUMMER MADNESS` (the automatic BXGY discount) keeps working exactly
 * as it does today. This is a UI layer only.
 *
 * Trigger logic:
 *  - Hooks both fetch() and XMLHttpRequest calls to /cart/add(.js),
 *    so it works regardless of whether the theme's add-to-cart uses
 *    fetch or jQuery/XHR (Ella's internals aren't visible from here,
 *    so both are covered defensively).
 *  - After a successful add, checks /cart.js — if item_count === 1,
 *    this really was the first item, so the popup fires.
 *  - Fallback: also checks on load if the visitor lands on /cart
 *    directly (covers "redirect to cart page" as the theme's
 *    after-add-to-cart setting, in case that path is a full page
 *    reload rather than an AJAX call).
 *  - Shows once per browser session (sessionStorage) so it doesn't
 *    nag on every page.
 *
 * NOT yet handled / worth checking after paste-in:
 *  - Assumes every product is eligible for the offer (true for ~all
 *    18 collections SUMMER MADNESS is scoped to). If Decision B in
 *    marketing/second-pair-offer.md excludes clearance models later,
 *    this script does not know about that exclusion and would still
 *    nudge on a clearance item. Revisit then.
 *  - Copy below is a placeholder — brand voice (CLAUDE.md §3) is
 *    still empty, so treat this text as a draft, not final.
 */
(function () {
  "use strict";

  var STORAGE_KEY = "solful_second_pair_nudge_shown";
  var CART_ADD_PATTERN = /\/cart\/add(\.js)?(\?|$)/;

  function alreadyShown() {
    try { return sessionStorage.getItem(STORAGE_KEY) === "1"; }
    catch (e) { return false; }
  }
  function markShown() {
    try { sessionStorage.setItem(STORAGE_KEY, "1"); } catch (e) {}
  }

  function injectStyles() {
    if (document.getElementById("sspp-styles")) return;
    var css = ""
      + "#solful-second-pair-popup{position:fixed;inset:0;background:rgba(0,0,0,0);"
      + "display:flex;align-items:flex-end;justify-content:center;z-index:99999;"
      + "opacity:0;transition:opacity .25s ease;pointer-events:none;}"
      + "#solful-second-pair-popup.sspp-show{opacity:1;background:rgba(0,0,0,.35);pointer-events:auto;}"
      + "#solful-second-pair-popup.sspp-hide{opacity:0;}"
      + "#solful-second-pair-popup .sspp-card{background:#fff;color:#111;max-width:420px;"
      + "width:calc(100% - 32px);margin:0 auto 24px;border-radius:14px;padding:22px 20px 20px;"
      + "position:relative;box-shadow:0 10px 40px rgba(0,0,0,.25);transform:translateY(16px);"
      + "transition:transform .25s ease;text-align:center;font-family:inherit;}"
      + "#solful-second-pair-popup.sspp-show .sspp-card{transform:translateY(0);}"
      + "@media(min-width:640px){#solful-second-pair-popup{align-items:center;}"
      + "#solful-second-pair-popup .sspp-card{margin-bottom:0;}}"
      + ".sspp-close{position:absolute;top:10px;right:12px;background:none;border:0;"
      + "font-size:22px;line-height:1;cursor:pointer;color:#888;}"
      + ".sspp-icon{font-size:28px;margin-bottom:6px;}"
      + ".sspp-title{font-size:19px;font-weight:700;margin-bottom:6px;}"
      + ".sspp-body{font-size:14px;line-height:1.5;color:#444;margin-bottom:16px;}"
      + ".sspp-cta{background:#111;color:#fff;border:0;border-radius:999px;padding:11px 22px;"
      + "font-size:14px;font-weight:600;cursor:pointer;}";
    var style = document.createElement("style");
    style.id = "sspp-styles";
    style.textContent = css;
    document.head.appendChild(style);
  }

  function showPopup() {
    if (alreadyShown()) return;
    if (document.getElementById("solful-second-pair-popup")) return;

    injectStyles();

    var overlay = document.createElement("div");
    overlay.id = "solful-second-pair-popup";
    overlay.innerHTML =
      '<div class="sspp-card" role="dialog" aria-live="polite" aria-label="Second pair offer">' +
        '<button type="button" class="sspp-close" aria-label="Close">&times;</button>' +
        '<div class="sspp-icon">🕶️🕶️</div>' +
                '<div class="sspp-title">End of summer — second pair 50% off</div>' +
        '<div class="sspp-body">Closing out the season: add a second pair and it’s 50% off, applied automatically at checkout.</div>' +
        '<button type="button" class="sspp-cta">Continue shopping</button>' +
      '</div>';
    document.body.appendChild(overlay);
    markShown();

    function close() {
      overlay.classList.add("sspp-hide");
      overlay.classList.remove("sspp-show");
      setTimeout(function () { overlay.remove(); }, 250);
    }
    overlay.querySelector(".sspp-close").addEventListener("click", close);
    overlay.querySelector(".sspp-cta").addEventListener("click", close);
    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) close();
    });

    setTimeout(function () {
      requestAnimationFrame(function () { overlay.classList.add("sspp-show"); });
    }, 10);
  }

  function checkCartAndMaybeShow() {
    fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.item_count === 1) {
          showPopup();
        }
      })
      .catch(function () {});
  }

  // 1) Catch AJAX add-to-cart via fetch()
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function () {
      var target = arguments[0];
      var url = target && target.url ? target.url : target;
      var isAdd = typeof url === "string" && CART_ADD_PATTERN.test(url);
      var p = origFetch.apply(this, arguments);
      if (isAdd) {
        p.then(function (res) {
          if (res && res.ok) checkCartAndMaybeShow();
          return res;
        }).catch(function () {});
      }
      return p;
    };
  }

  // 2) Catch AJAX add-to-cart via XMLHttpRequest (jQuery / older ajax carts)
  (function () {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__ssppIsAdd = typeof url === "string" && CART_ADD_PATTERN.test(url);
      return origOpen.apply(this, arguments);
    };
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      if (this.__ssppIsAdd) {
        this.addEventListener("load", function () {
          if (this.status >= 200 && this.status < 300) checkCartAndMaybeShow();
        });
      }
      return origSend.apply(this, arguments);
    };
  })();

  // 3) Fallback: theme setting "After adding to cart" = redirect to /cart
  document.addEventListener("DOMContentLoaded", function () {
    if (/\/cart(\?|$)/.test(window.location.pathname)) {
      checkCartAndMaybeShow();
    }
  });
})();